"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const colors = exports.colors = {
  white: "rgba(255, 255, 255, 1)",
  lightWhite: "rgba(255, 255, 255, 0.7)",
  lightestWhite: "rgba(255, 255, 255, 0.5)",
  accent: "rgba(76, 127, 230, 1)",
  accentLabelFill: "rgba(76, 127, 230, .1)",
  accentActiveFill: "rgba(76, 127, 230, .05)",
  accentLight: "rgba(86, 137, 240, 1)",
  accentDark: "rgba(65, 112, 204, 100)",
  accentFocusInput: "rgba(69, 119, 237, 1)",
  dropDownWindowListItemBackground: "rgba(69, 119, 237, .2)",
  red: "rgba(244, 81, 100, 1)",
  redLabelFill: "rgba(244, 81, 100, .1)",
  yellow: "rgba(251, 200, 93, 1)",
  yellowLabelFill: "rgba(251, 200, 93, .1)",
  turquoise: "rgba(0, 181, 146, 1)",
  turquoiseLabelFill: "rgba(0, 181, 146, .1)",
  teal: "rgba(0, 189, 227, 1)",
  tealLabelFill: "rgba(0, 189, 227, .1)",
  black: "rgba(21, 25, 30, 1)",
  lightBlack: "rgba(21, 25, 30, .7)",
  lightestBlack: "rgba(21, 25, 30, .5)",
  border: "rgba(207, 214, 230, 1)",
  borderLight: "rgba(207, 214, 230, .1)",
  nonPrimaryLinkHover: "rgba(171, 180, 190, 1)",
  svgFill: "rgba(61, 65, 75, 1)",
  nonPrimaryLinkActive: "rgba(61, 65, 75, 0.9)",
  nonPrimaryLinkColor: "rgba(61, 65, 75, 0.7)",
  greyInput: "rgba(61, 65, 75, 0.5)",
  greyLabel: "rgba(61, 65, 75, .35)",
  grey: "rgba(61, 65, 75, .25)",
  tag: "rgba(61, 65, 75, 0.05)",
  greyLabelFill: "rgba(174, 174, 177, .1)",
  pillActiveBackground: "rgba(246, 249, 255, 1)",
  blueGradient: "rgba(82, 109, 248, 1)",
  pinkGradient: "rgba(246, 70, 156, 1)",
  yellowGradient: "rgba(255, 254, 129, 1)",
  remainingGradient: "rgba(223, 229, 239, 1)",
  topHeaderBorder: "rgba(220, 233, 255, 1)",
  topHeaderProfileBorder: "rgba(205, 213, 218, 1)",
  topHeaderBackground: "rgba(16, 29, 51, 1)",
  dropdownHover: "rgba(219, 229, 253, 1)",
  tableHeaderBackgroundColor: "rgba(249, 250, 252, 1)",
  tableHeaderBorderColor: "rgba(203, 219, 242, 1)",
  tableHeaderTextColor: "rgba(120, 133, 159, 1)",
  dropDownWindowBorder: "rgba(202, 209, 223, 1)",
  dropDownWindowListItemIcon: "rgba(41, 180, 240, 1)",
  datePickerDay: "rgba(101, 117, 135, 1)",
  datePickerBorder: "rgba(195, 205, 217, 1)",
  defaultLogo: "rgba(249, 77, 99, 1)",
  defaultSvg: "rgba(0, 0, 0, 1)",
  greyIconSvg: "rgba(173, 175, 177, 1)",
  calendarBlue: "rgba(69, 119, 237, .8)",
  sambaLogoBackground: "rgba(52, 51, 76, 1)",
  sidebarBackground: "rgba(33, 33, 48, 1)"
};

const fontFamily1 = exports.fontFamily1 = "'Helvetica Neue', Helvetica, Arial, sans-serif";

const calcPadding = exports.calcPadding = factor => factor * 4;

const defaultBody = exports.defaultBody = `
  font-family: ${fontFamily1};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
`;